export default "__VITE_ASSET__ebae02b5__"